import React, { useState } from 'react';

import { SearchIcon } from './Icons';
import { useMessages } from './i18n';
import { searchUrl } from './links';

// Course search box in the learner header (inserted after the main menu in
// org.openedx.frontend.layout.header_desktop_main_menu.v1).
const HeaderSearch = () => {
  const t = useMessages();
  const [query, setQuery] = useState('');

  return (
    <form
      className="bm-header-search"
      role="search"
      onSubmit={(e) => { e.preventDefault(); window.location.assign(searchUrl(query)); }}
    >
      <label htmlFor="bm-header-search" className="sr-only">{t.searchButton}</label>
      <input
        id="bm-header-search"
        type="search"
        value={query}
        placeholder={t.search}
        onChange={(e) => setQuery(e.target.value)}
      />
      <button type="submit" aria-label={t.searchButton}><SearchIcon /></button>
    </form>
  );
};

// Phones: the course search under the header (org.openedx.frontend.layout.header_mobile.v1,
// after the default header; the header only renders this slot on small screens).
export const MobileHeaderSearch = () => (
  <div className="bm-mobile-search"><HeaderSearch /></div>
);

export default HeaderSearch;
